// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2GYOu","alertIcon":"ConfirmModal_alertIcon__W50Lv"};